import { render, staticRenderFns } from "./show.page.vue?vue&type=template&id=2a538ecb&scoped=true&"
import script from "./show.page.vue?vue&type=script&lang=js&"
export * from "./show.page.vue?vue&type=script&lang=js&"
import style0 from "./show.page.vue?vue&type=style&index=0&id=2a538ecb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a538ecb",
  null
  
)

export default component.exports